"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 16 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ThemesViewDTO_1 = require("../model/ThemesViewDTO");

var ThemeConverter_1 = require("./ThemeConverter");

var ThemesViewDTOConverter_1 = require("./ThemesViewDTOConverter");
/**
 * Default implementation of ThemesViewDTOConverter.
 *
 * @author JMt
 */


var ThemesViewDTOConverterImpl =
/*#__PURE__*/
function (_ThemesViewDTOConvert) {
  _inherits(ThemesViewDTOConverterImpl, _ThemesViewDTOConvert);

  function ThemesViewDTOConverterImpl(themeConverter) {
    var _this;

    _classCallCheck(this, ThemesViewDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThemesViewDTOConverterImpl).call(this));
    _this.themeConverter = themeConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ThemesViewDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ThemesViewDTO_1.ThemesViewDTO(this.themeConverter.toObject(source.theme, conversions), ThemesViewDTO_1.ThemesViewDTO.schema.windowCount.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {}; //Object.assign(result, conversions.classToDocumentId(source));

      Object.assign(result, {
        theme: this.themeConverter.toDocument(source.theme, conversions),
        windowCount: source.windowCount
      });
      return result;
    }
  }]);

  return ThemesViewDTOConverterImpl;
}(ThemesViewDTOConverter_1.ThemesViewDTOConverter);

ThemesViewDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ThemeConverter_1.ThemeConverter])], ThemesViewDTOConverterImpl);
exports.ThemesViewDTOConverterImpl = ThemesViewDTOConverterImpl;